// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  seedId: __t.u64().primaryKey().name("seed_id"),
  personaId: __t.u64().name("persona_id"),
  version: __t.u32(),
  prompt: __t.string(),
  cardJson: __t.string().name("card_json"),
  publishedAt: __t.i64().name("published_at"),
  publishedBy: __t.string().name("published_by"),
});
